import React, { useEffect ,useState} from 'react'
import { connect } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import {
  PostAuthoriseAction,
  GetAccessTokenAction,

} from './../features/auth/redux/authAction'
import axios from 'axios'
/* 
executes outside of main SPA bundle!
should be a stateless volatile component
*/
function Callback({ ...props }) {
  const navigate = useNavigate()

  return (
    <div>
      <h1></h1>
     <h3 style={{ marginLeft: '5vw' }}></h3>
    </div>
  )
}

const mapStateToProps = state => ({
  
})
const mapActionsToProps = {
  PostAuthoriseAction,
  GetAccessTokenAction,
  
}

export default connect(mapStateToProps, mapActionsToProps)(Callback)
